import React from "react";
import PropTypes from "prop-types";

import FaMapO from "react-icons/lib/fa/map-o";
import IoInformatcircled from "react-icons/lib/io/informatcircled";
import IoIosInformatoutline from "react-icons/lib/io/ios-informatoutline";
import GoInfo from "react-icons/lib/go/info";
import MdFullscreen from "react-icons/lib/md/fullscreen";
import MdFullscreenExit from "react-icons/lib/md/fullscreen-exit";
import MdPanoramaHorizontal from "react-icons/lib/md/panorama-horizontal";

import PlayerMenuItem from "./PlayerMenuItem";
import Styles from "./PlayerMenu.styles";

const PlayerMenu = props => (
  <div style={{ ...Styles.menu, ...props.bottomStyle }}>
    {props.hasGyroscope && (
      <PlayerMenuItem
        color={props.color}
        onClick={props.toggleGyroscope}
        isSelected={props.useGyroscope}
      >
        <MdPanoramaHorizontal size={30} />
      </PlayerMenuItem>
    )}
    {props.project.map && (<PlayerMenuItem
      color={props.color}
      onClick={props.toggleMinimap}
      isSelected={props.isMinimapShown}
    >
      <FaMapO size={26} />
    </PlayerMenuItem>)}
    <PlayerMenuItem
      color={props.color}
      onClick={props.toggleHotSpots}
      isSelected={props.isHotSpotsShown}
    >
      <IoInformatcircled size={28} />
    </PlayerMenuItem>

    <PlayerMenuItem
      color={props.color}
      onClick={props.toggleFullScreen}
      isSelected={props.fullscreen}
    >
      {props.fullscreen ? (
        <MdFullscreenExit size={30} />
      ) : (
        <MdFullscreen size={30} />
      )}
    </PlayerMenuItem>
  </div>
);

PlayerMenu.defaultProps = {
  toggleFullScreen: () => {},
  toggleHotSpots: () => {},
  isMinimapShown: false
};
PlayerMenu.propTypes = {
  project: PropTypes.object,
  toggleMinimap: PropTypes.func.isRequired,
  toggleFullScreen: PropTypes.func,
  toggleHotSpots: PropTypes.func,
  isMinimapShown: PropTypes.bool
};
export default PlayerMenu;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMenu/PlayerMenu.js